import useQuizzes from '../stores/useQuizzes';

export default async function isQuizPage(
  e: CustomEvent | Array<string>,
  id: object | string
) {
  // Takes an event that contains a list of quizzes or an array of quiz ids and a page id
  // returns boolean, tests if the pageID contains a quiz question from the list of quizzes
  const useQuizzes = (await import('../stores/useQuizzes')).default;
  const { getQuizUnits } = useQuizzes();
  const pageId = typeof id === 'object' ? id.value : id;
  let canReset = false;
  const quizzes = e.detail?.quizzes
    ? e.detail.quizzes
    : Array.isArray(e)
      ? e
      : [];
  quizzes.forEach(q => {
    // getQuizUnits returns a Set
    getQuizUnits(q)?.forEach(unit => {
      if (unit === pageId) {
        canReset = true;
      }
    });
  });
  return canReset;
}
